"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const wallet_adapter_1 = require("@jup-ag/wallet-adapter");
const react_1 = __importStar(require("react"));
const react_2 = require("react");
const preferredExplorer_1 = require("./preferredExplorer");
const noop = () => { };
const WalletContextProvider = ({ autoConnect, children, }) => {
    const enableWalletPassthrough = (() => {
        if (typeof window === 'undefined')
            return undefined;
        return window.Jupiter.enableWalletPassthrough;
    })();
    const wallets = (0, react_2.useMemo)(() => {
        if (enableWalletPassthrough) {
            return [];
        }
        return [];
    }, [enableWalletPassthrough]);
    const [showWalletStatus, setShowWalletStatus] = (0, react_1.useState)({
        show: false,
        message: '',
    });
    const ShouldWrapWalletProvider = (0, react_2.useMemo)(() => {
        return enableWalletPassthrough
            ? react_1.default.Fragment
            : ({ children }) => ((0, jsx_runtime_1.jsx)(wallet_adapter_1.UnifiedWalletProvider, { wallets: wallets, config: {
                    env: 'mainnet-beta',
                    autoConnect: typeof autoConnect !== 'undefined' ? autoConnect : true,
                    metadata: {
                        name: 'Jupiter Plugin',
                        url: 'https://plugin.jup.ag',
                        description: 'An open-sourced, lite version of Jupiter that provides end-to-end swap flow by linking it in your HTML. Check out the visual demo for the various integration modes below.          ',
                        iconUrls: [],
                    },
                    hardcodedWallets: [],
                    walletPrecedence: [],
                    notificationCallback: {
                        onConnect: noop,
                        onConnecting: noop,
                        onDisconnect: noop,
                        onNotInstalled: ({ walletName, metadata }) => {
                            setShowWalletStatus({
                                show: true,
                                message: ((0, jsx_runtime_1.jsxs)("p", { className: "space-y-1", children: [walletName, " is not installed.", (0, jsx_runtime_1.jsxs)("p", { className: "space-x-1", children: [(0, jsx_runtime_1.jsxs)("a", { className: "underline font-semibold", target: "_blank", rel: "noopener noreferrer", href: metadata.url, children: ["Visit ", walletName, " website"] }), (0, jsx_runtime_1.jsx)("span", { children: "to install it." })] })] })),
                            });
                            setTimeout(() => {
                                setShowWalletStatus({
                                    show: false,
                                    message: '',
                                });
                            }, 5000);
                        },
                    },
                    theme: 'jupiter',
                }, children: children }));
    }, [autoConnect, enableWalletPassthrough, wallets]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ShouldWrapWalletProvider, { children: children }), showWalletStatus.show && showWalletStatus.message ? ((0, jsx_runtime_1.jsx)("div", { className: "absolute bottom-2 w-full px-2", children: (0, jsx_runtime_1.jsx)("div", { className: "w-full h-full bg-white/10 rounded-lg p-2 text-warning text-xs", children: showWalletStatus.message }) })) : null] }));
};
const ContextProvider = (props) => {
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(WalletContextProvider, Object.assign({}, props, { children: (0, jsx_runtime_1.jsx)(preferredExplorer_1.PreferredExplorerProvider, { defaultExplorer: props.defaultExplorer, children: props.children }) })) }));
};
exports.ContextProvider = ContextProvider;
